import { Popup } from '@leverege/ui-elements';
import { useCallback } from 'react';
import RsrcSortModel from "./RsrcSortModel.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function RsrcSortModelEditor(props) {
  const {
    value,
    onChange: pOnChange
  } = props;
  const field = RsrcSortModel.getSort(value, 0)?.field;
  const onClick = useCallback(({
    data
  }) => {
    const sorts = RsrcSortModel.getSorts(value);
    const nModel = sorts.length > 0 ? RsrcSortModel.setSort(value, 0, {
      field: data,
      order: 'DESC'
    }) : RsrcSortModel.addSort(value, {
      field: data,
      order: 'DESC'
    });
    pOnChange({
      value: nModel
    });
  }, [value, pOnChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Popup.Item, {
      eventData: "path",
      onClick: onClick,
      checkStyle: "radio",
      checked: field === 'path',
      value: field === 'path',
      children: "Sort by Path"
    }), /*#__PURE__*/_jsx(Popup.Item, {
      eventData: "createdAt",
      onClick: onClick,
      checkStyle: "radio",
      checked: field === 'createdAt',
      value: field === 'createdAt',
      children: "Sort by Created"
    })]
  });
}